import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { trackCtaClick } from "../../utilities/tracking";

// Mobile-only sticky CTA pinned to the bottom of the viewport on the HCP site.
// Stays visible as the user scrolls and routes straight to the contact form.
// Hidden on the contact page itself and the standalone PI page.
const HIDE_ON = ["/hcp/contact-us", "/hcp/pi"];

export default function StickyCta() {
  const location = useLocation();

  if (HIDE_ON.includes(location.pathname)) return null;

  return (
    <NavLink
      to="/hcp/contact-us"
      className="sticky-cta"
      onClick={() =>
        trackCtaClick({
          text: "Contact us",
          destination: "/hcp/contact-us",
          location: "sticky-mobile-footer",
        })
      }
    >
      Contact us
    </NavLink>
  );
}
